import { css } from '@emotion/react'
import { medium } from '../../GlobalStyles'

export const SidebarStyle = css` 

    width: 100%;
    background-color: #fff;
    border-right: 1px solid #ede7f3;
    overflow: auto;
    position: fixed;
    position: -webkit-sticky;
    position: -moz-sticky;
    position: sticky;
    top: 52px;

    ${medium}{
        display: none;
    }

    a{
        outline-offset: -2px;
    }


  
    .rightSideTitle {
    font-size: 10px;
    line-height: 1;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1.2px;
    padding: 7px 24px 7px 16px;
    border-left: 1px solid #B5BABE;
    }

    .rightSideBarUL {
    margin-top: 32px;
    background: var(--main-bg);
    }

    .rightSideBarUL li {
    list-style-type: none;
    border-left: 1px solid #B5BABE;
    
    }

    .rightSideBarUL li a {
    font-size: 12px;
    font-weight: 500;
    line-height: 1.5;
    padding: 7px 24px 7px 16px;
    }

`


export const ListItemStyle = () => css`
    
  list-style: none;

  a {
    color: #5c6975;
    text-decoration: none;
    font-weight: ${({ level }) => (level === 0 ? 700 : 400)};
    padding: 0.45rem 0 0.45rem ${props => 2 + (props.level || 0) * 1}rem;
    display: block;
    position: relative;

    &:hover {
      color: rgb(116, 76, 188) !important;
    }

    ${props =>
    props.active &&
      `
      color: #663399;
      border-color: rgb(230,236,241) !important;
      border-style: solid none solid solid;
      border-width: 1px 0px 1px 1px;
      background-color: #fff;
    `} // external link icon
    svg {
      float: right;
      margin-right: 1rem;
    }
  }
`
